import { render, staticRenderFns } from "./BeneficiaryAddStepTwo.vue?vue&type=template&id=d394a0f0&scoped=true&"
import script from "./BeneficiaryAddStepTwo.vue?vue&type=script&lang=js&"
export * from "./BeneficiaryAddStepTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d394a0f0",
  null
  
)

export default component.exports